import { createAction, props } from '@ngrx/store';
import { IFile } from '@shared';

export enum FilesActionTypes {
  GET_FILES = '[Basic Data] Get Files',
  GET_FILES_SUCCESS = '[Basic Data] Get Files Success',
  GET_FILES_FAILURE = '[Basic Data] Get Files Failure',

  UPLOAD_FILE = '[Basic Data] Upload File',
  UPLOAD_FILE_SUCCESS = '[Basic Data] Upload File Success',
  UPLOAD_FILE_FAILURE = '[Basic Data] Upload File Failure',

  DELETE_FILE = '[Basic Data] Delete File',
  DELETE_FILE_SUCCESS = '[Basic Data] Delete File Success',
  DELETE_FILE_FAILURE = '[Basic Data] Delete File Failure',
}

export const getFiles = createAction(FilesActionTypes.GET_FILES, props<{ id: number }>());

export const getFilesSuccess = createAction(FilesActionTypes.GET_FILES_SUCCESS, props<{ files: IFile[] }>());

export const getFilesFailure = createAction(FilesActionTypes.GET_FILES_FAILURE);

export const uploadFile = createAction(
  FilesActionTypes.UPLOAD_FILE,
  props<{ id: number; file: File; file_type: string }>(),
);

export const uploadFileSuccess = createAction(FilesActionTypes.UPLOAD_FILE_SUCCESS, props<{ file: IFile }>());

export const uploadFileFailure = createAction(FilesActionTypes.UPLOAD_FILE_FAILURE);

export const deleteFile = createAction(FilesActionTypes.DELETE_FILE, props<{ id: number }>());

export const deleteFileSuccess = createAction(FilesActionTypes.DELETE_FILE_SUCCESS, props<{ id: number }>());

export const deleteFileFailure = createAction(FilesActionTypes.DELETE_FILE_FAILURE);
